import React from 'react'
import PropTypes from 'prop-types'

import { shuffleArray } from 'utils'

import CancellationReason from './CancellationReason'

class CancellationQuestion extends React.Component {
  constructor (props) {
    super(props)

    this.reasons = this.formatReasons()
  }

  formatReasons () {
    // If 'Other' option is specified: remove it, shuffle array, then append 'Other' to end
    let reasons = this.props.question.reasons.slice(0) // Copy reasons array
    let other

    if (reasons[0].key === 0) {
      other = reasons.shift()
    }

    reasons = shuffleArray(reasons)

    if (other) reasons.push(other)

    return reasons
  }

  render () {
    const reasons = this.reasons.map(reason => (
      <CancellationReason
        key={reason.key}
        question={this.props.question}
        reason={reason}
        selected={this.props.surveyState['selectedReason' + this.props.question.key] === reason.key}
        details={this.props.surveyState[this.props.detailsStateKey(this.props.question.key, reason.key)]}
        onReasonChange={this.props.onReasonChange}
        onDetailsChange={this.props.onDetailsChange}
      />
    ))

    return (
      <div className='CancellationQuestion'>
        <h3>{this.props.question.text}</h3>
        {reasons}
      </div>
    )
  }
}

CancellationQuestion.propTypes = {
  question: PropTypes.object.isRequired,
  surveyState: PropTypes.object.isRequired,
  detailsStateKey: PropTypes.func.isRequired,
  onReasonChange: PropTypes.func.isRequired,
  onDetailsChange: PropTypes.func.isRequired
}

export default CancellationQuestion
